import React from "react";
import { withRouteData, NavLink } from "react-static";
import Moment from "react-moment";
import Markdown from "react-markdown";
import { Head } from "react-static";
import PostStyle from "../styles/offre.style";
import { LazyImage } from 'react-lazy-images'
import { truncate } from "../helpers/utils";
import right_arrow from "../assets/right-arrow.svg";
import { withLocalize, Translate } from 'react-localize-redux'

const EmploymentPage = ({ post, similar, ...props }) => {
  return (
    <PostStyle>
      <Head>
        <title> Investiv Group | Offre De Emploi </title>
      </Head>

      <div className="xs-12 content new">
        <div className="xs-12 header">
          <div className="in-header-content">
            <h3><Translate id="offre.top.one"/> </h3>
            <p> <Translate id="offre.top.zero"/> </p>
            <span> <Translate id="offre.top.two"/> <Moment format="MMMM Do, YYYY">{new Date()}</Moment> </span>
          </div>
        </div>

        <div className="xs-12 md-10 md-off-1 lifted">
          <div className="xs-12 t-c">

          </div>
          <div className="xs-12 md-10 md-off-1">
          <br/>
          <br/>
          <h2><Translate id="offre.header.one"/></h2>
          <p><Translate id="offre.text.one"/></p>
          <br/>
          <p><Translate id="offre.text.two"/></p>
          <br/>
          <h2><Translate id="offre.header.two"/></h2>
          <p><Translate id="offre.text.three"/></p>
          <ul>
            <li><Translate id="offre.list.one"/></li>
            <li><Translate id="offre.list.two"/></li>
            <li><Translate id="offre.list.three"/></li>
            <li><Translate id="offre.list.four"/></li>
            <li><Translate id="offre.list.five"/></li>
            <li><Translate id="offre.list.six"/></li>
          </ul>
          <br/>
          <h2><Translate id="offre.header.four"/></h2>
          <p><Translate id="offre.text.four"/></p>
          <br/>
          <h4><Translate id="offre.header.five"/></h4>
          <ul>
            <li><Translate id="offre.list.seven"/></li>
            <li><Translate id="offre.list.eight"/></li>
          </ul>
          <ul><li><Translate id="offre.list.nine"/>
          </li>
          </ul>
          <br/>

          <h2>
            <Translate id="offre.header.three"/>
          </h2>

          <p>
            <Translate id="offre.text.five"/>
              <NavLink style={{ display: "inline", paddingLeft: 0 }} to="/careers">
                <Translate id="link.here"/>
              </NavLink>
          </p>

          </div>
        </div>

      </div>
    </PostStyle>
  );
}

let EmploymentPageWithRouteData = withRouteData(withLocalize(EmploymentPage));
export default EmploymentPageWithRouteData;



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/offre-d-emploi.js